var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 34,
    viewBox: "0 0 44 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8502 21.3503L30.4886 10.7618L28.3502 8.62342L19.8502 17.1234L15.6002 12.8734L13.4926 14.9811L19.8502 21.3503ZM0.769531 33.9617V30.9618H43.2309V33.9617H0.769531ZM6.61568 28.9618C5.60541 28.9618 4.75028 28.6118 4.05028 27.9118C3.35028 27.2118 3.00028 26.3566 3.00028 25.3464V4.57726C3.00028 3.56703 3.35028 2.71191 4.05028 2.01191C4.75028 1.31191 5.60541 0.961914 6.61568 0.961914H37.3848C38.395 0.961914 39.2502 1.31191 39.9502 2.01191C40.6502 2.71191 41.0002 3.56703 41.0002 4.57726V25.3464C41.0002 26.3566 40.6502 27.2118 39.9502 27.9118C39.2502 28.6118 38.395 28.9618 37.3848 28.9618H6.61568ZM6.61568 25.9618H37.3848C37.5386 25.9618 37.6797 25.8977 37.8079 25.7695C37.9361 25.6413 38.0002 25.5003 38.0002 25.3464V4.57726C38.0002 4.4234 37.9361 4.28237 37.8079 4.15417C37.6797 4.02593 37.5386 3.96182 37.3848 3.96182H6.61568C6.46181 3.96182 6.32076 4.02593 6.19253 4.15417C6.06433 4.28237 6.00023 4.4234 6.00023 4.57726V25.3464C6.00023 25.5003 6.06433 25.6413 6.19253 25.7695C6.32076 25.8977 6.46181 25.9618 6.61568 25.9618Z",
    fill: "#139FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.2c5ca63eaf652d2a205338e26fc08c35.svg";
export { ForwardRef as ReactComponent };